/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Task context information
 */
export type TaskContext = {
    /**
     * Conversation associated with the task.
     */
    conversationId?: number;
    /**
     * Execution identity for idempotent follow-up replacement.
     */
    employeeFollowUp?: {
        /**
         * Employee execution that owns this follow-up.
         */
        executionId: string;
    };
    /**
     * Stable provenance for idempotent employee task creation.
     */
    employeeOperation?: {
        /**
         * Task-producing operation kind.
         */
        operationKind: TaskContext.operationKind;
        /**
         * Stable operation key within the execution.
         */
        operationKey: string;
        /**
         * Execution requesting this task.
         */
        executionId: string;
    };
};
export namespace TaskContext {
    /**
     * Task-producing operation kind.
     */
    export enum operationKind {
        TASK_CREATE = 'task-create',
        FOLLOW_UP_REPLACE = 'follow-up-replace',
    }
}

